import React from "react"
import { OnboardingSiteType } from "@modules/onboarding/shared/constants"
import LoadingFromExternalWindow from "@modules/ui/components/LoadingFromExternalWindow"

export function AuthorizingWindow({
  formattedName,
  onAuthorizing,
  cmsVendor,
  siteId,
  type,
}) {
  return (
    <div data-cy="authorizing-window">
      <LoadingFromExternalWindow
        style={{ minHeight: `calc(100vh - 15rem)` }}
        message={`We just opened a new browser window to authenticate with ${formattedName}. Accidentally closed the window?`}
        onClick={() => {
          if (onAuthorizing()) {
            return null // early return for dev & test purpose
          }

          const oauthUrl = `${
            process.env.GATSBY_DASHBOARD_AUTHENTICATION_URL
          }/oauth/${cmsVendor.toLowerCase()}?siteId=${siteId}${
            type === OnboardingSiteType.Provision ? `&provision=true` : ``
          }`

          window.open(
            oauthUrl,
            `_blank`,
            process.env.NODE_ENV === `production` ? `height=600,width=700` : ``
          )
        }}
      />
    </div>
  )
}
